import { render, staticRenderFns } from "./LeaderboardTable.vue?vue&type=template&id=9a0bee80&scoped=true"
import script from "./LeaderboardTable.vue?vue&type=script&lang=js"
export * from "./LeaderboardTable.vue?vue&type=script&lang=js"
import style0 from "./LeaderboardTable.vue?vue&type=style&index=0&id=9a0bee80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0bee80",
  null
  
)

export default component.exports